window.Visualizations.Composites.SideBySideSunburst = Object.assign({}, window.Visualizations.Highcharts.Base, {
  setup(opts) {
    const container = document.getElementById(opts.containerID);
    if (!container) return;

    const childSunbursts = container.querySelector('.child-sunbursts');
    if (!childSunbursts) return;

    const inputArrows = (arrow) => {
      const input = arrow.parentElement?.querySelector('input');
      if (!input) return;

      let baseVal = parseInt(input.value, 10);
      const max = parseInt(input.getAttribute('max'), 10);
      const min = parseInt(input.getAttribute('min'), 10);

      if (arrow.className.match(/up/) && baseVal < max) {
        childSunbursts.querySelectorAll('.arrow-up').forEach((hiddenArrow) => hiddenArrow.click());
        baseVal += 1;
      } else if (arrow.className.match(/down/) && baseVal > min) {
        childSunbursts.querySelectorAll('.arrow-down').forEach((hiddenArrow) => hiddenArrow.click());
        baseVal -= 1;
      }

      if (baseVal === parseInt(input.value, 10)) return;
      input.value = String(baseVal);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    container.querySelectorAll('.side-by-side-sunburst-input [class^=arrow-]').forEach((arrow) => {
      arrow.addEventListener('click', () => inputArrows(arrow));
    });
  }
});
